<div class="custom-container" [ngClass]="{'no-result-container': !filteredCCUs.length && !fromEquipmentBuilder, 'no-result-container-eb': !filteredCCUs.length && fromEquipmentBuilder}">
    <div class="custom-header">
    
        <div class="header-search scope-list-search">
            <!--Sequence Name (Equipment Builder)-->
            <div class="equipment-builder-header-title" *ngIf="fromEquipmentBuilder">
                <div class="large-text"><span class="large-text-bold">Apply: </span>{{ sequenceName }}</div>
                <p class="info-text small-text">Select one or more devices to apply this sequence</p>
            </div>
            
            <mat-form-field class="search-input search-zones">
                <input matInput [placeholder]="fromEquipmentBuilder ? (dialogData.equipmentType === 'system' ? 'Search for Systems/Devices' : 'Search for Zones/Devices') : 'Search for devices'"
                [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
                    autofocus="false" #searchTextField autocomplete="off" class="search-input-field" />
                <i class="fas fa-search search-icon" matPrefix aria-hidden="true"></i>
                <i *ngIf="searchText" (click)="clearSearch()" class="fa fa-times clear-search-icon" matSuffix
                    aria-hidden="true"></i>
            </mat-form-field>
        </div>
    </div>
    <div class="invalid-model-message" *ngIf="invalidModels.length && !isHierarchyLoading">
        <div class="info-txt">Following models are invalid</div>
        <div class="invalid-models-list">
            <span *ngFor="let model of invalidModels; let last = last" class="invalid-model">{{ model.name }}<span *ngIf="!last">; </span></span>
        </div>

    </div>
    <div class="invalid-model-message" *ngIf="hasMismatchedSelectedDevices() && !isHierarchyLoading">
        <div class="info-txt">{{ getDeviceTypeMismatchMessage() }}</div>
    </div>

    <div class="custom-body hierarchy-list-container" [ngClass]="{'no-result-body': !filteredCCUs.length}">
        <ng-container *ngFor="let ccu of filteredCCUs">
            <app-accordion [blockTitle]="ccu.ccuName" [isOpen]="dropdownAccordion[ccu.ccuName]" [showBlockTooltip]="ccu?.otaStatus"
                [blockIconPath]="getStatusIconPath(ccu.otaStatus)"
                (accordianState)="dropdownListAccordion(ccu.ccuName)" class="accordion-item m-b-4">

                <ng-container *ngIf="getHierarchyGroups(ccu).length > 0; else noGroupsTemplate">

                    <!-- All select checkbox for the CCU & For Equip Builder only for zones -->
                    <label class="list-item" *ngIf="!(fromEquipmentBuilder && dialogData.equipmentType == 'system')">
                        <mat-checkbox
                            [checked]="areAllGroupsSelected(ccu)"
                            [indeterminate]="areSomeGroupsSelected(ccu) && !areAllGroupsSelected(ccu)"
                            (change)="toggleAllGroups(ccu, $event.checked)"
                            [disabled]="isCCUDisabled(ccu)">
                            
                        </mat-checkbox>
                        <span class="list-item-label" [ngClass]="{'disabled': isCCUDisabled(ccu)}">
                            {{fromEquipmentBuilder ? 'All Zones': 'All'}}
                        </span>
                    </label>
                    
                    <div *ngFor="let group of getHierarchyGroups(ccu)" class="list-container">
                        <label class="list-item" [ngClass]="{'disabled': isGroupDisabled(group)}">
                            <mat-checkbox
                                [checked]="areAllDevicesSelected(group)" 
                                [disabled]="isGroupDisabled(group)"
                                [indeterminate]="areSomeDevicesSelected(group) && !areAllDevicesSelected(group)"
                                (change)="toggleAllDevices(group, $event.checked)">
                            </mat-checkbox>
                            <span class="list-item-label" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow
                                [ngClass]="{'disabled': isGroupDisabled(group)}">
                                {{ getGroupName(group, ccu) }}
                            </span>
                            <div class="status-icon-container" *ngIf="group?.otaStatus && !isGroupDisabled(group)">
                                <img class="status-icon" [src]="getStatusIconPath(group.otaStatus)" alt="" id="status-image"
                                    [matTooltip]="group.otaStatus" matTooltipPosition='below' matTooltipClass="ota-status-tooltip">
                            </div>
                        </label>

                        <ng-container *ngIf="group?.devices && group?.devices.length ; else noDevicesTemplate">
                            <div *ngFor="let device of group.devices" class="list-container">
                                <label class="list-item nested" [ngClass]="{'disabled': isGroupDisabled(group)}"
                                    (mouseout)="unhoveredFunction()" (mouseover)="hoveredFunction($event, isDeviceDisabled(device), device)">

                                    <mat-checkbox
                                        [checked]="selectedDevicesMap[device.deviceRef] || false"
                                        [disabled]="isDeviceDisabled(device)"
                                        (change)="onDeviceChange(device.deviceRef, $event)">
                                    </mat-checkbox>
                                    <span class="list-item-label" matTooltip="" matTooltipPosition='above' showTooltipOnOverflow
                                        [ngClass]="{'disabled': isDeviceDisabled(device)}">
                                        {{ device.deviceName }}
                                    </span>
                                    <div class="status-icon-container" *ngIf="device?.otaStatus && !(isDeviceDisabled(device))">
                                        <img class="status-icon" [src]="getStatusIconPath(device.otaStatus)" alt="" id="status-image"
                                            [matTooltip]="device.otaStatus" matTooltipPosition='below' matTooltipClass="ota-status-tooltip">
                                    </div>
                                </label>
                            </div>
                            
                        </ng-container>

                    </div>

                </ng-container>

                <ng-template #noGroupsTemplate>
                    <div class="no-zones-text">No groups with Low Code Equip to show.</div>
                </ng-template>

                <ng-template #noDevicesTemplate>
                    <div class="no-zones-text">No Devices to show.</div>
                </ng-template>

            </app-accordion>
        </ng-container>
        
        <ng-container *ngIf="isHierarchyLoading">
            <div class="hierarchy-loader-container">
                <ngx-skeleton-loader
                    [theme]="{ 'border-radius': '0', 'height': '25px', 'background-color': '#eff0f1'}" count="2">
                </ngx-skeleton-loader>
            </div>
        </ng-container>

        <ng-container *ngIf="!filteredCCUs.length && !isHierarchyLoading">
            <div class="no-result-text">{{CCUS.length > 0 ? 'No result found.' : 'No CCUs paired with low-code equipment are found.'}} </div>
        </ng-container>


    </div>


    <div class="custom-footer">
        <button class="footer-button left-button" [disabled]="isHierarchyLoading || originalAppliedList.length==0" (click)="getDeliveryLogs()" *ngIf="!fromEquipmentBuilder">DELIVERY LOG</button>
        <button class="footer-button left-button" (click)="closePopup()" *ngIf="fromEquipmentBuilder">BACK</button>
        <button class="footer-button right-button" [class.btn-loading]="isApiInProgress"
            [disabled]="isHierarchyLoading || disableApplySequence() || isApiInProgress" (click)="applySequence()">
            APPLY SEQUENCE
            <img *ngIf="isApiInProgress" class="btn-loader-icon" src="assets/images/loader.gif" alt="Loading">
        </button>
    </div>
      
    <div class="custom-tooltip" [ngClass]="{'visibility-show': tooltip}" id="custom-hierarchy-tooltip">
        <div class="tooltip-header entity-tooltip">
            <div class="tool-text" [innerHTML]="customTooltipText"></div>
        </div>
    </div>
</div>
